import React from "react";
import AppButton from "../../../../components/AppButton";
import { useAppToast } from "../../../../components/AppToastProvider";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const toastTriggers = [
  { key: "success", label: "Success", message: "Gespeichert" },
  { key: "info", label: "Info", message: "Datenstand aktualisiert" },
  { key: "warning", label: "Warning", message: "Nicht alle Daten wurden übernommen" },
  { key: "error", label: "Error", message: "Speichern fehlgeschlagen" },
];

const niceToKnowItems = [
  "Varianten: success, info, warning und error.",
  "Icon + Farbe kommt automatisch von Variante.",
  "Dauer: success/info 3s, warning 4s, error 5s.",
];

function ToastPreview() {
  const toast = useAppToast();

  return (
    <div className="ds-docs-preview-surface ds-docs-toast-preview">
      <div className="ds-docs-toast-preview__actions">
        {toastTriggers.map((trigger) => (
          <AppButton
            key={trigger.key}
            className="ds-docs-toast-preview__button"
            variant="primary"
            size="sm"
            onClick={() => toast[trigger.key](trigger.message)}
          >
            {trigger.label}
          </AppButton>
        ))}
      </div>
      <AppButton className="ds-docs-toast-preview__clear" variant="neutral" size="sm" onClick={() => toast.clear()}>
        Stack leeren
      </AppButton>
    </div>
  );
}

export default function ToastsDocs() {
  return (
    <DocsSectionCard title="Toasts">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--toasts">
        <DocsPreviewPanel className="ds-docs-toast-preview-panel">
          <ToastPreview />
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
